import { AxiosResponse } from 'axios';
import API from 'core/Api';
import { createErrorFromResponse } from 'core/Error';
import { Dispatch } from 'react';
import { IModalProps } from 'store/modal';

type Options = {
  showModal: (props: IModalProps) => void;
  id: number | string;
  callback?: (res: any) => void;
  setIsLoading?: Dispatch<React.SetStateAction<boolean>>;
};

type HandlePreview = (options: Options) => Promise<void>;

const cb: (res: any) => void = (res: AxiosResponse<any>) => {
  setTimeout(() => {
    window.open(res.data, '_blank');
  });
};

const handlePreviewDoc: HandlePreview = ({ showModal, id, callback = cb, setIsLoading }) => {
  if (setIsLoading) {
    setIsLoading(true);
  }
  return API.get(`documents/${id}/download`)
    .then(callback)
    .catch(res => {
      const error = createErrorFromResponse(res);
      showModal({
        type: 'error',
        content: error.message,
      });
    })
    .finally(() => {
      if (setIsLoading) {
        setIsLoading(false);
      }
    });
};

export default handlePreviewDoc;
